import React, { useState, useContext, Fragment } from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import Button from "./Button";
import { getCart, saveCart } from "../utils/localstorage";
import PRODUCTS from "../../public/assets/products.json";
import { CartContext } from "../contexts/CartContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SiteSelection from "./SiteSelection";

const Affiliate = () => {
  const [referral, setReferral] = useState(null); // true / false
  const [referralConfirmed, setReferralConfirmed] = useState(false);
  const cartContext = useContext(CartContext);
  const cart = getCart();
  const brochuresProduct = PRODUCTS.find((p) => p.Sku === "B3Bro5");
  const b3BookProduct = PRODUCTS.find((p) => p.Sku === "B3Book5Fr");
  const navigate = useNavigate();
  const [prefix, setPrefix] = useState("");
  const [available, setAvailable] = useState("");

  const onChangeReferral = (value) => {
    setReferral(value);
    localStorage.setItem("referral", value);

    const productExists = cart.some(
      (item) => item.product.Sku === brochuresProduct.Sku
    );

    if (value && !productExists) {
      cartContext.save([
        ...cart,
        { product: brochuresProduct, qty: 1 },
        { product: b3BookProduct, qty: 1 },
      ]);
      toast(`${brochuresProduct.ProductName} Added!`);
      toast(`${b3BookProduct.ProductName} Added!`);
    } else if (!value && productExists) {
      const updatedCart = cart.filter(
        (item) =>
          item.product.Sku !== brochuresProduct.Sku &&
          item.product.Sku !== b3BookProduct.Sku
      );
      cartContext.save(updatedCart);
      toast(`${brochuresProduct.ProductName} Removed`);
      toast(`${b3BookProduct.ProductName} Removed`);
    }
  };

  const checkAvailability = () => {
    if (prefix.length > 25) {
      return;
    }
    fetch(
      `${process.env.REACT_APP_API_URI}/api/Member/replicatedwebsite/${prefix}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.replicatedNameOnWebSite) {
          setAvailable("Taken");
        } else {
          localStorage.setItem("memberWebsitePrefix", prefix);
          setAvailable("Available");
        }
      });
  };

  const onContinue = () => {
    const cart = getCart();
    if (prefix) {
      if (available === "Available") {
        localStorage.setItem("currentRoute", "detail");
        saveCart(cart);
        navigate("/shipping");
      } else {
        toast.error("Please check Website availability");
      }
    } else {
      toast.error("Please select Website URL");
    }
  };

  return (
    <Fragment>
      {!referralConfirmed && (
        <section className="container mt-4 mx-auto flex-1 p-0 md:p-1 flex flex-col lg:max-w-3xl relative">
          <div className="flex flex-col gap-2">
            <div className="bg-[#302b2b] p-6 rounded-[1rem] w-full">
              <h1 className="pb-2 text-[2.33rem] text-xl md:text-2xl roboto-medium">
                <span className="text-white">
                  Free B<span className="text-[#00adef] mr-2">3</span>
                  Affiliate Program!
                </span>
              </h1>

              {/* Desktop Content */}
              <div className="hidden md:block roboto-light">
                <p className="pb-2 text-[#00adef] text-xl text-white">
                  Start sharing wellness and earning income, it’s simple and
                  free.
                </p>
                <p className="pb-2 text-[#00adef] text-2xl text-white roboto-medium">
                  What You Get:
                </p>
                <ul className="list-disc pl-4 pb-2">
                  <li className="pt-1 text-xl text-white">
                    <span className="text-[#00adef]">
                      Your Own Personalized Website
                    </span>{" "}
                    – Perfect for sharing with friends, family, and clients
                  </li>
                  <li className="pt-2 text-xl text-white">
                    <span className="text-[#00adef]">Effortless Sharing</span> –
                    Just send your unique link, we’ll handle the rest
                  </li>
                  <li className="pt-2 text-xl text-white">
                    <span className="text-[#00adef]">
                      {" "}
                      Earn Great Commissions{" "}
                    </span>{" "}
                    – Earn{" "}
                    <span className="roboto-regular">
                      $100 Direct Tier and $40 Referral Tier
                    </span>{" "}
                    per B3 Band Set
                  </li>
                  <li className="pt-2 text-xl text-white">
                    <span className="text-[#00adef]">Free Affiliate Kit</span> –
                    Includes 5 Tri-Fold Brochures and 5 B3 Booklets to share
                    with your community
                    <span className="text-sm">
                      {" "}
                      (4.99 shipping fee applies if no other products ordered)
                    </span>
                  </li>
                </ul>
              </div>

              {/* Mobile Content - Disclosure */}
              <div className="md:hidden roboto-regular mt-4">
                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white px-4 py-2 text-left text-lg font-medium text-[#00adef] focus:outline-none">
                        <span>Details</span>
                        <ChevronUpIcon
                          className={`${
                            open ? "rotate-180 transform" : ""
                          } h-5 w-5 text-[#00adef]`}
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="pt-4 pb-2 text-white text-md">
                        <p className="text-white pb-2 roboto-light">
                          Start sharing wellness and earning income, it’s simple
                          and free.
                        </p>
                        <p className="pb-2 md:hidden text-[#00adef] text-xl text-white roboto-medium">
                          What You Get:
                        </p>
                        <ul className="list-disc pl-4 pb-2 roboto-light">
                          <li className="py-1">
                            <span className="text-[#00adef]">
                              Your Own Personalized Website
                            </span>{" "}
                            – Perfect for sharing with friends, family, and
                            clients
                          </li>
                          <li className="py-1">
                            <span className="text-[#00adef]">
                              Effortless Sharing{" "}
                            </span>{" "}
                            – Just send your unique link, we’ll handle the rest
                          </li>
                          <li className="py-1">
                            <span className="text-[#00adef]">
                              {" "}
                              Earn Great Commissions{" "}
                            </span>{" "}
                            – Earn{" "}
                            <span className="roboto-regular">
                              $100 Direct Tier and $40 Referral Tier
                            </span>{" "}
                            per B3 Band Set
                          </li>
                          <li className="pt-1 text-white">
                            <span className="text-[#00adef]">
                              Free Affiliate Kit
                            </span>{" "}
                            – Includes 5 Tri-Fold Brochures and 5 B3 Booklets to
                            share with your community
                            <span className="text-sm">
                              {" "}
                              (4.99 shipping fee applies if no other products
                              ordered)
                            </span>
                          </li>
                        </ul>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              </div>
              <p className="py-3 md:py-2 text-[#00adef] text-2xl roboto-medium">
                Please choose one to continue:
              </p>
              <label className="grid grid-cols-[1.25rem_auto] items-start gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="affiliate-option"
                  className="w-4 h-4 mt-2 accent-[#00adef]"
                  checked={referral === true}
                  onChange={() => onChangeReferral(true)}
                />
                <span className="text-xl roboto-light text-white pt-1">
                  Yes, set me up with my free affiliate site for sharing.
                </span>
              </label>

              <label className="grid grid-cols-[1.25rem_auto] mt-1 items-start gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="affiliate-option"
                  className="w-4 h-4 mt-2 accent-[#00adef]"
                  checked={referral === false}
                  onChange={() => onChangeReferral(false)}
                />
                <span className="text-xl roboto-light text-white pt-1">
                  No, I don’t want the affiliate site at this time.
                </span>
              </label>
            </div>

            <div className="text-center pt-4">
              <Button
                onClick={() => {
                  if (referral === false) {
                    localStorage.setItem("referral", false);
                    navigate("/shipping");
                  } else if (referral === true) {
                    setReferralConfirmed(true);
                  }
                }}
                disabled={referral === null}
                data-mdb-ripple="true"
                data-mdb-ripple-color="light"
                className={`mx-auto !w-full text-base md:text-lg px-5 py-2 rounded-full font-light mt-2 lg:max-w-[300px] ${
                  referral === null ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                Continue
              </Button>
            </div>
          </div>
        </section>
      )}

      {referral === true && referralConfirmed && (
        <SiteSelection
          checkAvailability={checkAvailability}
          onContinue={onContinue}
          setPrefix={setPrefix}
          available={available}
          prefix={prefix}
          heading={
            <span className="md:ml-5">
              Choose your <span className="text-black">B</span>3 Affiliate
              website
            </span>
          }
        />
      )}
    </Fragment>
  );
};

export default Affiliate;
